export default __webpack_public_path__ + "static/media/codesnip_1.234dc7e3.png";